module.exports = __webpack_public_path__ + "static/media/play_on_start_icon.88bfd883.svg";